module.exports = __webpack_public_path__ + "img/فولدر-قفل-دار-a4.ee86b9a5.png";